import { render, staticRenderFns } from "./PTPTNExport.vue?vue&type=template&id=38e8b77a"
import script from "./PTPTNExport.vue?vue&type=script&lang=js"
export * from "./PTPTNExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports